import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login            from './pages/Login';
import Registro         from './pages/Registro';
import OrcamentoPublico from './pages/OrcamentoPublico';
import Dashboard        from './pages/Dashboard';
import ProdutoList      from './pages/ProdutoList';
import ProdutoForm      from './pages/ProdutoForm';
import OrcamentoList    from './pages/OrcamentoList';
import ClienteForm      from './pages/ClienteForm';
import ClienteList      from './pages/ClienteList';
import FornecedorForm   from './pages/FornecedorForm';
import FornecedorList   from './pages/FornecedorList';
import EditarFornecedor from './pages/EditarFornecedor';
import EntradaList      from './pages/EntradaList';
import SaidaList        from './pages/SaidaList';
import PedidoList       from './pages/PedidoList';
import Configuracoes    from './pages/Configuracoes';
import AdminSistema     from './pages/AdminSistema';
import LaudoList        from './pages/LaudoList';
import OrdemServicoList from './pages/OrdemServicoList';
import NotFound         from './pages/NotFound';
import ProtectedRoute   from './components/ProtectedRoute';
import Layout           from './components/Layout';

function LayoutRoute({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

// ── Plan limit modal (rendered inside Router so useNavigate works) ────────────

function PlanLimitModal() {
  const navigate = useNavigate();
  const [modal, setModal] = useState(null);

  useEffect(() => {
    const handler = (e) => setModal(e.detail);
    window.addEventListener('plan-limit', handler);
    return () => window.removeEventListener('plan-limit', handler);
  }, []);

  if (!modal) return null;

  const PLANO_LABELS = { trial: 'Trial', starter: 'Starter', pro: 'Pro' };

  const handleUpgrade = () => {
    setModal(null);
    navigate('/configuracoes?tab=plano');
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, fontFamily: 'Montserrat, sans-serif',
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, maxWidth: 420, width: '90%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.25)', overflow: 'hidden',
      }}>
        <div style={{ background: '#0D1B2A', padding: '20px 24px', display: 'flex', alignItems: 'center', gap: 12 }}>
          <span className="material-symbols-outlined" style={{ color: '#D4AF37', fontSize: 28 }}>workspace_premium</span>
          <div>
            <p style={{ color: '#D4AF37', fontWeight: 700, fontSize: 15, margin: 0 }}>Limite do plano atingido</p>
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12, margin: 0 }}>
              Plano atual: <strong style={{ color: '#fff' }}>{PLANO_LABELS[modal.plano] || modal.plano}</strong>
            </p>
          </div>
        </div>

        <div style={{ padding: '20px 24px 24px' }}>
          <p style={{ color: '#374151', fontSize: 14, lineHeight: 1.55, margin: '0 0 20px' }}>
            {modal.message}
          </p>

          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button
              onClick={() => setModal(null)}
              style={{
                padding: '9px 18px', borderRadius: 8, border: '1px solid #d1d5db',
                background: '#fff', color: '#374151', fontSize: 13, fontWeight: 600,
                cursor: 'pointer', fontFamily: 'Montserrat, sans-serif',
              }}
            >
              Fechar
            </button>
            <button
              onClick={handleUpgrade}
              style={{
                padding: '9px 20px', borderRadius: 8, border: 'none',
                background: '#D4AF37', color: '#0D1B2A', fontSize: 13, fontWeight: 700,
                cursor: 'pointer', fontFamily: 'Montserrat, sans-serif',
                display: 'flex', alignItems: 'center', gap: 6,
              }}
            >
              <span className="material-symbols-outlined" style={{ fontSize: 16 }}>rocket_launch</span>
              Ver planos
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <PlanLimitModal />
      <Routes>
        <Route path="/login"               element={<Login />} />
        <Route path="/registrar"           element={<Registro />} />
        <Route path="/orcamento/:token"    element={<OrcamentoPublico />} />

        <Route path="/dashboard"              element={<LayoutRoute><Dashboard /></LayoutRoute>} />
        <Route path="/produtos"               element={<LayoutRoute><ProdutoList /></LayoutRoute>} />
        <Route path="/produtos/novo"          element={<LayoutRoute><ProdutoForm /></LayoutRoute>} />
        <Route path="/produtos/editar/:id"    element={<LayoutRoute><ProdutoForm /></LayoutRoute>} />
        <Route path="/laudos"                 element={<LayoutRoute><LaudoList /></LayoutRoute>} />
        <Route path="/clientes"               element={<LayoutRoute><ClienteList /></LayoutRoute>} />
        <Route path="/clientes/novo"          element={<LayoutRoute><ClienteForm /></LayoutRoute>} />
        <Route path="/clientes/editar/:id"    element={<LayoutRoute><ClienteForm /></LayoutRoute>} />
        <Route path="/fornecedores"           element={<LayoutRoute><FornecedorList /></LayoutRoute>} />
        <Route path="/fornecedores/novo"      element={<LayoutRoute><FornecedorForm /></LayoutRoute>} />
        <Route path="/fornecedores/editar/:id" element={<LayoutRoute><EditarFornecedor /></LayoutRoute>} />
        <Route path="/entradas"               element={<LayoutRoute><EntradaList /></LayoutRoute>} />
        <Route path="/saidas"                 element={<LayoutRoute><SaidaList /></LayoutRoute>} />
        <Route path="/pedidos"                element={<LayoutRoute><PedidoList /></LayoutRoute>} />
        <Route path="/orcamentos"             element={<LayoutRoute><OrcamentoList /></LayoutRoute>} />
        <Route path="/ordens-servico"         element={<LayoutRoute><OrdemServicoList /></LayoutRoute>} />
        <Route path="/configuracoes"          element={<LayoutRoute><Configuracoes /></LayoutRoute>} />
        <Route path="/admin-sistema"          element={<LayoutRoute><AdminSistema /></LayoutRoute>} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
